import ArticleIcon from './assets/articleIcon.js'
import ButtonControl from '../button-control/index'
import TextButton from '../ui-components/TextButton'
import Title from './Title'
import DropdownControl from '../dropdown/DropdownControl'

const Header = (props) => {
  const { allowDrafts, draftSaved, hasUnsavedChanges, title, error, meta, onTitleChanged, onPublish, onSaveAsDraft, onCancel, onDeleteHandler } = props
  const onCancelHandler = !onCancel ? () => { window.location.assign('/moderation/overview') } : onCancel
  const draftButtonText = !draftSaved ? 'Save as draft' : hasUnsavedChanges ? 'Save changes' : 'All saved'
  const isDraftButtonDisabled = draftSaved && !hasUnsavedChanges

  return (
    <div class='control-header'>
      <div class='article-creator__article-icon-circle'>
        <ArticleIcon />
      </div>
      <Title
        title={title}
        error={error}
        meta={meta}
        onTitleChanged={(value) => onTitleChanged(value)}
        draftSaved={draftSaved}
      />
      <div class='article-creator__action-buttons'>
        { !draftSaved
          ? <TextButton
            class='qa-cancel article-creator__action-buttons-btn-cancel'
            onClick={onCancelHandler}>Cancel</TextButton>
          : null }
        <ButtonControl variant={!allowDrafts ? 'primary' : 'secondary'} title='Publish' class='qa-publish' onClick={onPublish} />
        { allowDrafts
          ? <ButtonControl
            variant='primary'
            title={draftButtonText}
            class={`qa-save-draft${draftSaved ? ' article-creator__action-buttons-btn-save-changes' : ''}`}
            onClick={onSaveAsDraft}
            disabled={isDraftButtonDisabled} />
          : null }
        { draftSaved
          ? <DropdownControl
            type={'button'}
            trigger={<ButtonControl icon={'moreHoriz'} class='btn-more-options' />}
            items={[{ title: 'Delete', onClick: onDeleteHandler, 'variant': 'danger', class: 'qa-delete-list-item' }]}
            align='right'
          />
          : null }
      </div>
    </div>
  )
}

export default Header
